import * as React from 'react';
import DraggableListItem from './DraggableListItem';
import {
  DragDropContext,
  OnDragEndResponder
} from 'react-beautiful-dnd';
import { StrictModeDroppable } from './StrictModeDroppable';
import { Item } from '../typings';

export type DraggableListProps = {
  items: Item[];
  onDragEnd: OnDragEndResponder;
};

const DraggableList = React.memo(({ items, onDragEnd, disabled }: DraggableListProps) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <StrictModeDroppable droppableId="droppable-list">
        {provided => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {items.map((item, index) => (
              <DraggableListItem item={item} index={index} disabled={disabled} key={item.id} />
            ))}
            {provided.placeholder}
          </div>
        )}
      </StrictModeDroppable>
    </DragDropContext>
  );
});

export default DraggableList;
